import React from 'react';
import { PRODUCT } from '../data/content';
const links = ['Términos y condiciones', 'Política de privacidad', 'Contacto'];
export function Footer() {
  return <footer className="w-full bg-oceano py-12 sm:py-14" data-id="element-35" data-mp="3ghc4m7ro7dqv">
      <div className="mx-auto w-full max-w-content px-5 text-center sm:px-8" data-id="element-36" data-mp="32ovuyo49khgz">
        <div className="inline-flex rounded-xl bg-polar px-6 py-4" data-id="element-37" data-mp="36oy0x9h17x22">
          <img src={PRODUCT.logo} alt="Atlas de Viajes" className="h-11 w-auto sm:h-12" data-id="element-38" data-mp="36n3c3k2n3ksp" />
        </div>

        <p className="mt-6 font-display text-[22px] font-bold leading-none text-polar" data-id="element-39" data-mp="38qw2zmvrtrp">
          Atlas de Viajes
        </p>
        <p className="mt-2 font-sans text-[11px] uppercase tracking-[0.16em] text-travertino" data-id="element-40" data-mp="3levi35gjnmhr">
          Tu guía para viajar
        </p>

        <p className="mx-auto mt-5 max-w-[34rem] font-sans text-[12.5px] leading-relaxed text-polar/60" data-id="element-41" data-mp="3qbvo5gde8p8v">
          Guías y recursos digitales para viajeros que eligen organizar sus propios viajes.
        </p>

        <nav aria-label="Enlaces del sitio" className="mt-7" data-id="element-42" data-mp="2ezl4q0kji5h3">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-43" data-mp="3lalgthavm9v0">
            {links.map(link => <li key={link} data-id="element-44" data-mp="3gbijyk51v9y4">
                <a href="#" className="font-sans text-[11.5px] text-polar/65 transition-colors duration-150 ease-out hover:text-caribe" data-id="element-45" data-mp="3gcjywzp6sgl4">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 border-t border-polar/10 pt-6 font-sans text-[11px] uppercase tracking-[0.12em] text-polar/40" data-id="element-46" data-mp="830gdarw9qws">
          © {new Date().getFullYear()} Atlas de Viajes
        </p>
      </div>
    </footer>;
}